import { NextPage } from "next";
import NextLink from "next/link";
import { useState, useEffect } from "react";
import { useRouter } from "next/router";

interface Props {
	href: string;
	children: any;
	className?: string;
	external?: boolean;
	exact?: boolean;
	active?: any;
	type?: "external" | "nav";
	[props: string]: any;
}

const CLink = ({ children, type, ...props }: Props) => {
	if (type == "nav") {
		return <NavLink {...props}>{children}</NavLink>;
	} else {
		return <NormalLink {...props}>{children}</NormalLink>;
	}
};

export default CLink;

const NormalLink = ({
	href,
	children,
	exact,
	className,
	active,
	external,
	...props
}: Props) => {
	if (external) {
		return (
			<a
				href={href}
				target="_blank"
				rel="noreferrer"
				className={className}
			>
				{children}
			</a>
		);
	} else {
		return (
			<NextLink href={href} className={className} {...props}>
				{children}
			</NextLink>
		);
	}
};

const NavLink = ({
	href,
	children,
	exact,
	className,
	active,
	...props
}: Props) => {
	const [classN, setClassN] = useState("");
	const { pathname, asPath } = useRouter();
	const isActive = exact
		? pathname === href
		: pathname.startsWith(href) || asPath.includes(href);

	const activeC = () => {
		if (typeof active === "string") {
			return active === "active" ? active : "";
		} else {
			return isActive ? "active" : "";
		}
	};

	useEffect(() => {
		setClassN(`${activeC()} ${className ? className : ""}`);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [pathname, asPath]);

	return (
		<CLink href={href} {...props} className={classN}>
			{children}
		</CLink>
	);
};

const CNavLink = ({
	href,
	children,
	exact,
	className,
	active,
	...props
}: any) => {
	const [classN, setClassN] = useState("");
	const { pathname, asPath } = useRouter();
	const isActive = exact
		? pathname === href
		: pathname.startsWith(href) || asPath.includes(href);

	const activeC = () => {
		if (typeof active === "string") {
			return active === "active" ? active : "";
		} else {
			return isActive ? "active" : "";
		}
	};

	useEffect(() => {
		setClassN(`${activeC()} ${className ? className : ""}`);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [pathname, asPath]);

	return (
		<CLink href={href} {...props} className={classN}>
			{children}
		</CLink>
	);
};

export { CNavLink };
